<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.user_name" placeholder="用户名" style="width:200px" />
      <el-input v-model="query.user_code" placeholder="用友编号" style="width:200px" />
      <el-select placeholder="状态" v-model="query.status">
        <el-option label="停用" value="0"></el-option>
        <el-option label="启用" value="1"></el-option>
      </el-select>
      <el-button type="primary" @click="getList">搜索</el-button>
    </div>

<!--
CREATE TABLE `sp_nc_user` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `user_name` varchar(20) DEFAULT NULL COMMENT '用户名称',
  `user_code` varchar(30) DEFAULT NULL COMMENT '用户编码',
  `identity_type` varchar(20) DEFAULT NULL COMMENT '身份类型',
  `identity` varchar(50) DEFAULT NULL COMMENT '身份',
  `business_id` int(5) DEFAULT NULL COMMENT '所属组织',
  `user_group` varchar(255) DEFAULT NULL COMMENT '所属用户组',
  `status` tinyint(1) DEFAULT '1' COMMENT '状态：0停用，1启用',
  `effective_time` datetime DEFAULT NULL COMMENT '生效日期',
  `create_time` datetime DEFAULT NULL,
  `update_time` datetime DEFAULT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 COMMENT='用友操作用户表';
-->

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="user_name" label="用户名" />
      <el-table-column prop="user_code" label="用友编号" />
      <el-table-column prop="identity_type" label="身份类型" />
      <el-table-column prop="identity" label="身份" />
      <el-table-column prop="business_id" label="所属组织" />
      <el-table-column prop="user_group" label="所属用户组" />
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status===1">启用</el-tag>
          <el-tag v-else>停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="effective_time" label="生效时间" />
      <el-table-column label="操作"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="pageChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next"
      :total="pageData.total"
      style="margin-top:15px;text-align:right"
    />
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'NcUser',
  data() {
    return {
      query: {
        user_name:"",
        user_code:"",
        status:""
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.user_name ? ['user_name', 'like', `%${this.query.user_name}%`] : null)
        .where(this.query.user_code ? ['user_code', 'like', `%${this.query.user_code}%`] : null)
        .where(this.query.status ? ['status', '=', this.query.status] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('NCUser/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {}
      this.dialogVisible = true
    },

    addYY(row) {
      const that = this;
      that.$confirm('确定添加到用友？').then(async () => {
        that.$message.success('将发起流程')
      })
    },

    // 编辑
    // async handleEdit(id) {
    //   const res = await api.detail(Params.ins().detail(id))
    //   if (res.code === 200) {
    //     this.form = res.data
    //     this.dialogVisible = true
    //   }
    // },
    //
    // // 提交保存
    // async submit() {
    //   const res = await api.save(Params.ins().save(this.form))
    //   if (res.code === 200) {
    //     this.$message.success('操作成功')
    //     this.dialogVisible = false
    //     this.getList()
    //   }
    // },
    //
    // // 删除
    // async handleDelete(id) {
    //   this.$confirm('确定删除？').then(async () => {
    //     const res = await api.delete(Params.ins().delete(id))
    //     if (res.code === 200) {
    //       this.$message.success('删除成功')
    //       this.getList()
    //     }
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/FinancialCenter/NcUser.vue